import ReCAPTCHA from 'react-google-recaptcha';

const Recaptcha = ({ show, callBack }) => {
    const recaptchaSiteKey = global?.recaptchaSiteKey;
    const showRecaptcha = show && recaptchaSiteKey;

    return (
        showRecaptcha && (
            <div className="recaptcha-container">
                <ReCAPTCHA sitekey={recaptchaSiteKey} onChange={callBack} />
            </div>
        )
    );
};

export default Recaptcha;
